/* eslint-env jquery */
const $ = jQuery.noConflict();
/* eslint-disable */
'use strict';
const HolidaysForm = {

	$domDropdownOptions: $('.js-holidays__dropdown-options'),
	$domHoliDrop: $('.js-holidays-dropdown'),
	$domHoliDropShown: $('.js-holidays__drop-sel-show'),
	$domHoliDropItem: $('.js-holidays__drop-sel-box-item'),
	classDropActive: 'drop-active',
	classSpanActive: 'span-active',

	$domHoliCheckboxes: $('.js-holidays__wrapper-input--checkboxes'),
	$domHoliCheck: $('.js-holidays__wrapper-input--checkbox'),
	classCheckActive: 'check-active',
	$domHolidaySubmit: $('.js-holiday-submit'),
	$domWrappCheck: $('.js-holidays__wrapper-check'),
	$domCheckTextarea: $('.js-holidays__drop-check-day-holi'),
	$domCheckTextareaUrg: $('.js-holidays__check-sel-urgent'),
	$domCheckPlaceholder: $('.js-holidays__drop-sel-show-placeholder'),
	input: 'input[type=submit]',
	classBoxSub: '.holidays__box-subtitle',
	$domBody: $('body'),
	/*-------------------------------------------------------------------------------
	# Initialize
	-------------------------------------------------------------------------------*/
	init: function() {
		/* this.holidaysTrigger(); */
		this.dropdownAppend();
		this.dropdownShow();
		this.checkAppend();
		this.checkItems();
		this.phoneNumberHolidays();
		$('.js-holidays__drop-sel-show-placeholder').hide();
		$('.js-holidays__wrapper-input--urgent').appendTo('.js-holidays__checkbox-urgent');
		$('.js-holidays__wrapper-input--regular').appendTo('.js-holidays__checkbox-regular');
	},

	checkAppend: function() {
		HolidaysForm.$domHoliCheckboxes.insertAfter(HolidaysForm.classBoxSub);
	},

	// allChecks: function() {
	// 	HolidaysForm.$domHoliCheck.on('click', function() {
	// 		if(HolidaysForm.$domHoliCheck.hasClass(HolidaysForm.classCheckActive)) {
	// 			const spanIn = $('.check-active').next().find('.js-holidays__drop-sel-show');
	// 			if(spanIn.text() === '') {
	// 				$(HolidaysForm.input).attr('disabled', 'disabled');
	// 			}else {
	// 				$(HolidaysForm.input).removeAttr('disabled');
	// 			}
	// 		}
	// 	});
	// },

	phoneNumberHolidays: function() {
		$('.js-holiday-checkbox').on('click', function() {
			$('.js-holiday-checkbox').find('.checkmark').removeClass('active');
			$(this).find('.checkmark').addClass('active');
			$('.js-holidays__checkbox').addClass('disabled');
			$(this).parents('.js-holidays__checkbox').removeClass('disabled');
			// remove input value when disabled
			$('.js-holidays__checkbox.disabled').find('.js-holiday__input-check').val('').css({'outline': 'none'});
		});

		$('.js-holiday-submit').on('click', function(e) {
			const clickEvent = e;
			const inputValue = $('.js-holidays__checkbox:not(.js-holidays__checkbox.disabled)').find('.js-holiday__input-check');
			const closedNum = $('.js-closed').val();
			const extension = $('.js-extension').val();
			const urgentNum = $('.js-urgent').val();
			const holidaysCheck = $('.js-holidays__wrapper-check--holidays');
			inputValue.each(function(e, el) {
				if(el.value === '') {
					clickEvent.preventDefault();
					$(el).css({'outline': '1px solid red'});
					// Scroll to $(el)
					$('html, body').animate({
						scrollTop: $(el).offset().top - 200
					}, 1000);
					return;
				}
				$(el).css({'outline': 'none'});
			});

			// Check to see if checkboxes are checked, and if not, it stops form submition and signalize which secton is required
			if(!$('.holidays__form-mid-box ').find('.js-holidays__wrapper-check--holidays .js-holidays__wrapper-input--checkbox-normal.check-active').length) {
				clickEvent.preventDefault();
				$('.js-schedule').css({
					'outline': '1px solid red',
					'outline-offset': '5px'
				});
				// Scroll to .holidays__form-mid-box
				$('html, body').animate({
					scrollTop: $('.holidays__form-mid-box').offset().top - 200
				}, 1000);
				return;
			}

			$('.js-schedule').css({'outline': 'none'});
			$('.js-closed-num').val(closedNum);
			$('.js-urgent-ext').val(extension);
			$('.js-urgent-num').val(urgentNum);
		});
	},

	checkItems: function() {
		HolidaysForm.$domHoliCheck.each(function() {
			$(this).on('click', function() {
				// const span = $(this).next().find('.js-holidays__drop-sel-show');
				// if(span.text() === '') {
				// 	$(HolidaysForm.input).attr('disabled', 'disabled');
				// }else {
				// 	$(HolidaysForm.input).removeAttr('disabled');
				// }

				if(!$(this).hasClass(HolidaysForm.classCheckActive)) {
					$(this).addClass(HolidaysForm.classCheckActive);
				}else {
					$(this).removeClass(HolidaysForm.classCheckActive);
					$(HolidaysForm.input).removeAttr('disabled');
				}
			});
		});

		HolidaysForm.$domHoliDropItem.on('click', function() {
			if($(this).parents('.js-holidays__drop-sel').prev().hasClass(HolidaysForm.classCheckActive)) {
				$(HolidaysForm.input).removeAttr('disabled');
			}
		});

		HolidaysForm.$domHolidaySubmit.on('click', function() {
			const label = $('.js-holidays__wrapper-input--checkbox-normal.check-active').find('label:first');
			let output = '';
			$(label).each(function() {
				const text = $(this).text();
				const input = $(this).parent().parent().find('.js-holidays__drop-sel-show');
				if(input.length > 0) {
					output += $(input).text() + ' - ' + text + '\n';
				}else {
					output += 'Closed - ' + text + '\n';
				}
			});

			HolidaysForm.$domCheckTextarea.val(output);

			const labelSec = $('.js-holidays__wrapper-check--urgent.check-active').find('label:first');
			let outputSec = '';
			$(labelSec).each(function() {
				const input = $(this).parent().parent().find('.holidays__wrapper-input input');
				outputSec += $(input).val() + '\n';
			});

			HolidaysForm.$domCheckTextareaUrg.val(outputSec);
		});

		$(document).on('click', function(e) {
			if($('.drop-active').length) {
				if($(e.target).is('.js-holidays__drop-sel-box') === false) {
					HolidaysForm.$domHoliDropShown.removeClass('drop-active');
					$('.js-holidays__drop-sel-box').stop().slideUp();
				}
			}
		});
	},

	dropdownAppend: function() {
		HolidaysForm.$domHoliDropShown.on('click', function(e) {
			$('.js-holidays__drop-sel-box').stop().slideUp();
			if(!$(this).hasClass(HolidaysForm.classDropActive)) {
				HolidaysForm.$domHoliDropShown.removeClass(HolidaysForm.classDropActive);
				$(this).addClass(HolidaysForm.classDropActive);
				$(this).next().stop().slideDown();
				e.stopPropagation();
			}else {
				$(this).removeClass(HolidaysForm.classDropActive);
				$(this).next().stop().slideUp();
			}
		});
	},

	dropdownShow: function() {
		HolidaysForm.$domHoliDropItem.on('click', function() {
			const txt = $(this).text();
			$(this).parent().parent().find('.holidays__drop-sel-show').text('');
			$(this).parent().parent().find('.holidays__drop-sel-show').text(txt);
			$(this).parent().parent().find('.holidays__drop-sel-show').addClass(HolidaysForm.classSpanActive);
			HolidaysForm.$domHoliDropShown.removeClass(HolidaysForm.classDropActive);
			HolidaysForm.$domHoliDropShown.next().stop().slideUp();
		});

		$('.js-holidays__drop-sel').each(function(i, el) {
			const list = $(el).find('.js-holidays__drop-sel-box li')[0];
			const firstOption = $(list).text();
			$(el).find('.js-holidays__drop-sel-show').text(firstOption);
		});
	},

	holidaysTrigger: function() {
		$('.js-holidays-form').submit((e) => {
			const pageId = $('.js-holidays-form').attr('data-cat');
			const companyName = $('.js-company-name').val();
			const phoneNumber = $('.js-phone').val();
			const email = $('.js-holidays-email').val();
			const contactInfo = $('.js-contact-info').val();
			const option = $('.js-holiday-option-select option:selected').text();

			const wrap = $('.holidays__wrapper-check');
			const arr = [];
			$(wrap).each(function(){
				const firstInp = $(this).find('input:first');
				if($(firstInp).is(':checked')) {
					$(firstInp).val('');
					const firstLabel = $(this).find('label:first');
					const lastInput = $(this).find('input:last');
					const obj = {
						checkbox: $(firstLabel).text(),
						input: $(lastInput) ? $(lastInput).val() : ''
					};
					arr.push(obj);
				}
			});

			const specialInstructions = $('.js-special-instructions').val();
			const extension = $('.js-extension').val();
			const comments = $('.js-comments').val();
			$.ajax({
				type: 'POST',
				// eslint-disable-next-line no-undef
				url: mongotelAjax.ajaxUrl,
				// eslint-disable-next-line no-undef,camelcase
				data: {
					action: 'getHolidays',
					// eslint-disable-next-line camelcase
					pageId: pageId,
					companyName: companyName,
					phoneNumber: phoneNumber,
					email: email,
					contactInfo: contactInfo,
					option: option,
					arr: JSON.stringify(arr),
					specialInstructions: specialInstructions,
					extension: extension,
					comments: comments
				}
			});
			e.preventDefault();
		});
	},
};

export default HolidaysForm;
